import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import {
	ClientFeatureOptions,
	FeaturedClearing,
	FeaturedPostgraduate,
	FeaturedUndergraduate,
	Gallery,
} from '@uc/web/shared/data-models';
import { UniversitySliderCopy } from '../models/university-slider.models';
import { UniversityGalleryComponent } from '@web/shared/ui';
import { CtaContainerComponent } from '../components/cta-container/cta-container.component';
import { RemoveDuplicateDomElementDirective } from '@uc/utilities';
import { Product } from '@uc/shared/data-models';

@Component({
	selector: 'uc-university-slider',
	templateUrl: './university-slider.component.html',
	imports: [
		RemoveDuplicateDomElementDirective,
		UniversityGalleryComponent,
		CtaContainerComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversitySliderComponent implements OnInit {
	uniName = input.required<string>();
	uniGallery = input.required<Gallery>();
	product = input.required<Product>();
	/**
	 * @id uniId | courseId
	 */
	id = input.required<number>();
	isFeaturedGallery = input.required<
		FeaturedUndergraduate | FeaturedPostgraduate | FeaturedClearing
	>();
	saved = input.required<number | boolean>();
	/**
	 * @delta
	 * 1 = uni
	 * 2 = course
	 */
	delta = input.required<1 | 2>();
	ugSearchOrderPosition = input<number | null>(null);
	cleSearchOrderPosition = input<number | null>(null);
	courseSlug = input<string>('');
	uniSliderCopy = input<UniversitySliderCopy>();
	paidFeatures = input<ClientFeatureOptions[]>();
	tab = input<string>('');
	academicYear = input<number>();

	mappedGallery!: Gallery;
	coverImage = '';

	ngOnInit(): void {
		this._createGallery();
	}

	private _createGallery(): void {
		if (!this.uniGallery()) return;

		this.coverImage = this.uniGallery().cover_image;

		this.mappedGallery = {
			...this.uniGallery(),
			images: [{ path: this.coverImage }, ...this.uniGallery().images],
			video: this.uniGallery().video,
		};
	}
}
